{
    "ar": {
      "Yes": "نعم",
      "No": "لا",
      "Cancel": "إلغاء",
      "Clear": "مسح",
      "Done": "تم",
      "Loading": "جار التحميل....",
      "Select": "اختر...",
      "Search": "بحث",
      "Back": "عودة",
      "OK": "حسنا",
      "dxCollectionWidget-noDataText": "لا يوجد بيانات لعرضها",
      "dxDropDownEditor-selectLabel": "اختر",
      "validation-required": "مطلوب",
      "validation-required-formatted": "{0} مطلوب",
      "validation-numeric": "يجب أن تكون القيمة رقم",
      "validation-numeric-formatted": "{0} يجب أن يكون رقم",
      "validation-range": "القيمة خارج المجال",
      "validation-range-formatted": "{0} خارج المجال",
      "validation-stringLength": "طول القيمة غير صحيح",
      "validation-stringLength-formatted": "طول ال {0} غير صحيح",
      "validation-custom": "القيمة غير صالحة",
      "validation-custom-formatted": "{0} غير صالح",
      "validation-async": "Value غير صالح",
      "validation-async-formatted": "{0} غير صالح",
      "validation-compare": "القيم غير متطابقة",
      "validation-compare-formatted": "{0} غير مطابق",
      "validation-pattern": "القيمة لا تطابق النمط",
      "validation-pattern-formatted": "{0} لا يطابق النمط",
      "validation-email": "Email غير صالح",
      "validation-email-formatted": "{0} غير صالح",
      "validation-mask": "Value غير صالح",
      "dxLookup-searchPlaceholder": "الحد الأدنى لعدد الأحرف: {0}",
      "dxList-pullingDownText": "للتحديث اسحب للأسفل...",
      "dxList-pulledDownText": "حرر للتحديث ...",
      "dxList-refreshingText": "تحديث...",
      "dxList-pageLoadingText": "جار التحميل...",
      "dxList-nextButtonText": "المزيد",
      "dxList-selectAll": "تحديد الكل",
      "dxListEditDecorator-delete": "حذف",
      "dxListEditDecorator-more": "المزيد",
      "dxScrollView-pullingDownText": "للتحديث اسحب للأسفل...",
      "dxScrollView-pulledDownText": "حرر للتحديث ...",
      "dxScrollView-refreshingText": "تحديث...",
      "dxScrollView-reachBottomText": "جار التحميل...",
      "dxDateBox-simulatedDataPickerTitleTime": "اختر وقت",
      "dxDateBox-simulatedDataPickerTitleDate": "اختر تاريخ",
      "dxDateBox-simulatedDataPickerTitleDateTime": "اختر تاريخ و وقت",
      "dxDateBox-validation-datetime": "القيمة يجب أن تكون وقت أو تاريخ",
      "dxFileUploader-selectFile": "اختر ملف",
      "dxFileUploader-dropFile": "أو أفلت الملف هنا",
      "dxFileUploader-bytes": "بايت",
      "dxFileUploader-kb": "كيلو بايت",
      "dxFileUploader-Mb": "ميغا بايت",
      "dxFileUploader-Gb": "غيغا بايت",
      "dxFileUploader-upload": "تحميل",
      "dxFileUploader-uploaded": "تم التحميل",
      "dxFileUploader-readyToUpload": "جاهز للتحميل",
      "dxFileUploader-uploadFailedMessage": "فشل التحميل",
      "dxFileUploader-invalidFileExtension": "نوع الملف غير مسموح به",
      "dxFileUploader-invalidMaxFileSize": "الملف كبير جدا",
      "dxFileUploader-invalidMinFileSize": "الملف صغير جدا",
      "dxRangeSlider-ariaFrom": "من",
      "dxRangeSlider-ariaTill": "حتى",
      "dxSwitch-switchedOnText": "يعمل",
      "dxSwitch-switchedOffText": "لا يعمل",
      "dxForm-optionalMark": "اختياري",
      "dxForm-requiredMessage": "{0} مطلوب",
      "dxNumberBox-invalidValueMessage": "القيمة يجب أن تكون رقم",
      "dxNumberBox-noDataText": "لا يوجد بيانات",
      "dxDataGrid-columnChooserTitle": "منتقى العمود",
      "dxDataGrid-columnChooserEmptyText": "اسحب العمود هنا لإخفائه",
      "dxDataGrid-groupContinuesMessage": "يستمر في الصفحة التالية",
      "dxDataGrid-groupContinuedMessage": "استمر من الصفحة السابقة",
      "dxDataGrid-groupHeaderText": "تجميع هذه العمود",
      "dxDataGrid-ungroupHeaderText": "فك تجميع",
      "dxDataGrid-ungroupAllText": "فك تجميع الكل",
      "dxDataGrid-editingEditRow": "تعديل",
      "dxDataGrid-editingSaveRowChanges": "حفظ",
      "dxDataGrid-editingCancelRowChanges": "إلغاء",
      "dxDataGrid-editingDeleteRow": "حذف",
      "dxDataGrid-editingUndeleteRow": "تجاهل الحذف",
      "dxDataGrid-editingConfirmDeleteMessage": "هل أنت متأكد أنك تريد حذف هذا السجل؟",
      "dxDataGrid-validationCancelChanges": "إلغاء التغييرات",
      "dxDataGrid-groupPanelEmptyText": "اسحب رأس العمود هنا للتجميع حسب ذلك العمود",
      "dxDataGrid-noDataText": "لا يوجد بيانات",
      "dxDataGrid-searchPanelPlaceholder": "بحث...",
      "dxDataGrid-filterRowShowAllText": "(الكل)",
      "dxDataGrid-filterRowResetOperationText": "إعادة تعيين",
      "dxDataGrid-filterRowOperationEquals": "يساوي",
      "dxDataGrid-filterRowOperationNotEquals": "لا يساوي",
      "dxDataGrid-filterRowOperationLess": "أقل من",
      "dxDataGrid-filterRowOperationLessOrEquals": "أقل أو يساوي",
      "dxDataGrid-filterRowOperationGreater": "أكبر من",
      "dxDataGrid-filterRowOperationGreaterOrEquals": "أكبر أو يساوي",
      "dxDataGrid-filterRowOperationStartsWith": "إبدأ ب",
      "dxDataGrid-filterRowOperationContains": "يحتوي",
      "dxDataGrid-filterRowOperationNotContains": "لا يحتوي",
      "dxDataGrid-filterRowOperationEndsWith": "ينتهي ب",
      "dxDataGrid-filterRowOperationBetween": "بين",
      "dxDataGrid-filterRowOperationBetweenStartText": "يبدأ",
      "dxDataGrid-filterRowOperationBetweenEndText": "ينتهي",
      "dxDataGrid-applyFilterText": "تطبيق الفلتر",
      "dxDataGrid-trueText": "صح",
      "dxDataGrid-falseText": "خطأ",
      "dxDataGrid-sortingAscendingText": "ترتيب تصاعدي",
      "dxDataGrid-sortingDescendingText": "ترتيب تنازلي",
      "dxDataGrid-sortingClearText": "مسح الترتيب",
      "dxDataGrid-editingSaveAllChanges": "حفظ التغيرات",
      "dxDataGrid-editingCancelAllChanges": "تجاهل التغييرات",
      "dxDataGrid-editingAddRow": "إضافة سطر",
      "dxDataGrid-summaryMin": "أقل: {0}",
      "dxDataGrid-summaryMinOtherColumn": "أقل ال {1} هو {0}",
      "dxDataGrid-summaryMax": "أكبر: {0}",
      "dxDataGrid-summaryMaxOtherColumn": "أكبر ال {1} هو {0}",
      "dxDataGrid-summaryAvg": "متوسط: {0}",
      "dxDataGrid-summaryAvgOtherColumn": "متوسط ال of {1} هو {0}",
      "dxDataGrid-summarySum": "مجموع: {0}",
      "dxDataGrid-summarySumOtherColumn": "مجموع ال {1} هو {0}",
      "dxDataGrid-summaryCount": "عدد: {0}",
      "dxDataGrid-columnFixingFix": "تصليح",
      "dxDataGrid-columnFixingUnfix": "عدم الاصلاح",
      "dxDataGrid-columnFixingLeftPosition": "إلى اليسار",
      "dxDataGrid-columnFixingRightPosition": "إلى اليمين",
      "dxDataGrid-exportTo": "تصدير",
      "dxDataGrid-exportToExcel": "تصدير إلى ملف إكسل",
      "dxDataGrid-exporting": "جار التصدير...",
      "dxDataGrid-excelFormat": "ملف إكسل",
      "dxDataGrid-selectedRows": "الأسطر المحددة",
      "dxDataGrid-exportSelectedRows": "تحديد الأسطر المحددة",
      "dxDataGrid-exportAll": "تصدير كل البيانات",
      "dxDataGrid-headerFilterEmptyValue": "(فارغ)",
      "dxDataGrid-headerFilterOK": "حسنا",
      "dxDataGrid-headerFilterCancel": "إلغاء",
      "dxDataGrid-ariaColumn": "عمود",
      "dxDataGrid-ariaValue": "قيمة",
      "dxDataGrid-ariaFilterCell": "فلتر الخلية",
      "dxDataGrid-ariaCollapse": "طي",
      "dxDataGrid-ariaExpand": "توسيع",
      "dxDataGrid-ariaDataGrid": "جدول البيانات",
      "dxDataGrid-ariaSearchInGrid": "بحث في جدول البيانات",
      "dxDataGrid-ariaSelectAll": "تحديد الكل",
      "dxDataGrid-ariaSelectRow": "تحديد سطر",
      "dxDataGrid-filterBuilderPopupTitle": "باني الفلتر",
      "dxDataGrid-filterPanelCreateFilter": "إنشاء فلتر",
      "dxDataGrid-filterPanelClearFilter": "مسح",
      "dxDataGrid-filterPanelFilterEnabledHint": "تفعيل الفلتر",
      "dxTreeList-ariaTreeList": "Tree list",
      "dxTreeList-editingAddRowToNode": "إضافة",
      "dxPager-infoText": "صفحة {0} من {1} ({2} عنصر)",
      "dxPager-pagesCountText": "من",
      "dxPivotGrid-grandTotal": "المجوع الكلي",
      "dxPivotGrid-total": "{0} مجموع",
      "dxPivotGrid-fieldChooserTitle": "منتقى الحقل",
      "dxPivotGrid-showFieldChooser": "عرض منتقي الحقل",
      "dxPivotGrid-expandAll": "توسيع الكل",
      "dxPivotGrid-collapseAll": "طي الكل",
      "dxPivotGrid-sortColumnBySummary": "ترتيب \"{0}\" حسب هذا العمود",
      "dxPivotGrid-sortRowBySummary": "ترتيب \"{0}\" حسب هذا السطر",
      "dxPivotGrid-removeAllSorting": "إزالة كافة الترتيب",
      "dxPivotGrid-dataNotAvailable": "غير متاح",
      "dxPivotGrid-rowFields": "حقول السطر",
      "dxPivotGrid-columnFields": "حقول العمود",
      "dxPivotGrid-dataFields": "حقول البيانات",
      "dxPivotGrid-filterFields": "حقول الفلتر",
      "dxPivotGrid-allFields": "كل الحقول",
      "dxPivotGrid-columnFieldArea": "قم بإفلات حقول العمود هنا",
      "dxPivotGrid-dataFieldArea": "قم بإفلات حقول البيانات هنا",
      "dxPivotGrid-rowFieldArea": "إفلات حقول السطور هنا",
      "dxPivotGrid-filterFieldArea": "إفلات حقول الفلترة هنا",
      "dxScheduler-editorLabelTitle": "موضوع",
      "dxScheduler-editorLabelStartDate": "تاريخ البداية",
      "dxScheduler-editorLabelEndDate": "تاريخ النهاية",
      "dxScheduler-editorLabelDescription": "وصف",
      "dxScheduler-editorLabelRecurrence": "تكرار",
      "dxScheduler-openAppointment": "فتح موعد",
      "dxScheduler-recurrenceNever": "أبدا",
      "dxScheduler-recurrenceMinutely": "كل دقيقة",
      "dxScheduler-recurrenceHourly": "كل ساعة",
      "dxScheduler-recurrenceDaily": "يوميا",
      "dxScheduler-recurrenceWeekly": "أسبوعيا",
      "dxScheduler-recurrenceMonthly": "شهريا",
      "dxScheduler-recurrenceYearly": "سنويا",
      "dxScheduler-recurrenceRepeatEvery": "كرر كل",
      "dxScheduler-recurrenceRepeatOn": "كرر في",
      "dxScheduler-recurrenceEnd": "إنهاء التكرار",
      "dxScheduler-recurrenceAfter": "بعد",
      "dxScheduler-recurrenceOn": "يعمل",
      "dxScheduler-recurrenceRepeatMinutely": "دقيقة/دقائق",
      "dxScheduler-recurrenceRepeatHourly": "ساعة/ساعات",
      "dxScheduler-recurrenceRepeatDaily": "يوم/أيام",
      "dxScheduler-recurrenceRepeatWeekly": "أسبوع/أسابيع",
      "dxScheduler-recurrenceRepeatMonthly": "شهر/أشهر",
      "dxScheduler-recurrenceRepeatYearly": "سنة/سنوات",
      "dxScheduler-switcherDay": "يوم",
      "dxScheduler-switcherWeek": "أسبوع",
      "dxScheduler-switcherWorkWeek": "أسبوع عمل",
      "dxScheduler-switcherMonth": "شهر",
      "dxScheduler-switcherAgenda": "جدول أعمال",
      "dxScheduler-switcherTimelineDay": "يوم المخطط الزمني",
      "dxScheduler-switcherTimelineWeek": "أسبوع المخطط الزمني",
      "dxScheduler-switcherTimelineWorkWeek": "أسبوع عمل المخطط الزمني",
      "dxScheduler-switcherTimelineMonth": "شهر المخطط الزمني",
      "dxScheduler-recurrenceRepeatOnDate": "بتاريخ",
      "dxScheduler-recurrenceRepeatCount": "حادثة/حوادث",
      "dxScheduler-allDay": "كل يوم",
      "dxScheduler-confirmRecurrenceEditMessage": "هل تريد تعديل هذا الموعد فقط أم السلسلة بأكملها؟",
      "dxScheduler-confirmRecurrenceDeleteMessage": "هل تريد حذف هذا الموعد فقط أم السلسلة بأكملها؟",
      "dxScheduler-confirmRecurrenceEditSeries": "تعديل السلاسل",
      "dxScheduler-confirmRecurrenceDeleteSeries": "حذف السلاسل",
      "dxScheduler-confirmRecurrenceEditOccurrence": "تعديل الموعد",
      "dxScheduler-confirmRecurrenceDeleteOccurrence": "حذف الموعد",
      "dxScheduler-noTimezoneTitle": "بلا منطقة زمنية",
      "dxScheduler-moreAppointments": "{0} مزيد",
      "dxCalendar-todayButtonText": "اليوم",
      "dxCalendar-ariaWidgetName": "التقويم",
      "dxColorView-ariaRed": "أحمر",
      "dxColorView-ariaGreen": "أخضر",
      "dxColorView-ariaBlue": "أزرق",
      "dxColorView-ariaAlpha": "شفاف",
      "dxColorView-ariaHex": "رمز اللون",
      "dxTagBox-selected": "{0} محدد",
      "dxTagBox-allSelected": "كل المحدد ({0})",
      "dxTagBox-moreSelected": "{0} مزيد",
      "vizExport-printingButtonText": "طباعة",
      "vizExport-titleMenuText": "تصدير/طباعة",
      "vizExport-exportButtonText": "{0} ملف",
      "dxFilterBuilder-and": "و",
      "dxFilterBuilder-or": "أو",
      "dxFilterBuilder-notAnd": "لا و",
      "dxFilterBuilder-notOr": "لا أو",
      "dxFilterBuilder-addCondition": "إضافة شرط",
      "dxFilterBuilder-addGroup": "إضافة مجموعة",
      "dxFilterBuilder-enterValueText": "<أدخل قيمة>",
      "dxFilterBuilder-filterOperationEquals": "يساوي",
      "dxFilterBuilder-filterOperationNotEquals": "لا يساوي",
      "dxFilterBuilder-filterOperationLess": "أقل من",
      "dxFilterBuilder-filterOperationLessOrEquals": "أصغر من أو يساوي",
      "dxFilterBuilder-filterOperationGreater": "أكبر من",
      "dxFilterBuilder-filterOperationGreaterOrEquals": "أكبر من أو يساوي",
      "dxFilterBuilder-filterOperationStartsWith": "يبدأ بـ",
      "dxFilterBuilder-filterOperationContains": "يحتوي",
      "dxFilterBuilder-filterOperationNotContains": "لا يحتوي",
      "dxFilterBuilder-filterOperationEndsWith": "ينتهي بـ",
      "dxFilterBuilder-filterOperationIsBlank": "فارغ",
      "dxFilterBuilder-filterOperationIsNotBlank": "غير فارغ",
      "dxFilterBuilder-filterOperationBetween": "بين",
      "dxFilterBuilder-filterOperationAnyOf": "أي من",
      "dxFilterBuilder-filterOperationNoneOf": "ليس من",
      "dxHtmlEditor-dialogColorCaption": "تغير لون الخط",
      "dxHtmlEditor-dialogBackgroundCaption": "تغير لون الخلفية",
      "dxHtmlEditor-dialogLinkCaption": "إضافة رابط",
      "dxHtmlEditor-dialogLinkUrlField": "عنوان الكتروني",
      "dxHtmlEditor-dialogLinkTextField": "نص",
      "dxHtmlEditor-dialogLinkTargetField": "فتح الرابط بنافذة جديدة",
      "dxHtmlEditor-dialogImageCaption": "إضافة صورة",
      "dxHtmlEditor-dialogImageUrlField": "عنوان الكتروني",
      "dxHtmlEditor-dialogImageAltField": "نصل بديل",
      "dxHtmlEditor-dialogImageWidthField": "عرض (بكسل)",
      "dxHtmlEditor-dialogImageHeightField": "طول (بكسل)",
      "dxHtmlEditor-heading": "ترويسة",
      "dxHtmlEditor-normalText": "نص عادي",
      "dxFileManager-newDirectoryName": "مجلد غير معنون",
      "dxFileManager-rootDirectoryName": "ملفات",
      "dxFileManager-errorNoAccess": "تم الرفض. تعذر إكمال العملية.",
      "dxFileManager-errorDirectoryExistsFormat": "مجلد '{0}'موجود مسبقا.",
      "dxFileManager-errorFileExistsFormat": "ملف '{0}' موجود مسبقاs.",
      "dxFileManager-errorFileNotFoundFormat": "ملف '{0}' غير موجود.",
      "dxFileManager-errorDirectoryNotFoundFormat": "مجلد '{0}' غير موجود.",
      "dxFileManager-errorWrongFileExtension": "لاحقة الملف غير مسموح به.",
      "dxFileManager-errorMaxFileSizeExceeded": "حجم الملف يتجاوز الحد الأقصى للحجم المسموح به.",
      "dxFileManager-errorInvalidSymbols": "هذا الاسم يحتوي على أحرف غير صالحة.",
      "dxFileManager-errorDefault": "خطأ غير محدد.",
      "dxFileManager-errorDirectoryOpenFailed": "لا يمكن فتح المجلد",
      "dxFileManager-commandCreate": "مجلد جديد",
      "dxFileManager-commandRename": "إعادة تسمية",
      "dxFileManager-commandMove": "نقل إلى",
      "dxFileManager-commandCopy": "نسخ إلى",
      "dxFileManager-commandDelete": "حذف",
      "dxFileManager-commandDownload": "تنزيل",
      "dxFileManager-commandUpload": "تحميل ملفات",
      "dxFileManager-commandRefresh": "تحديث",
      "dxFileManager-commandThumbnails": "عرض الصورة المصغرة",
      "dxFileManager-commandDetails": "عرض التفاصيل",
      "dxFileManager-commandClearSelection": "إلغاء التحديد",
      "dxFileManager-commandShowNavPane": "تبديل جزء التنقل",
      "dxFileManager-dialogDirectoryChooserMoveTitle": "نقل إلى",
      "dxFileManager-dialogDirectoryChooserMoveButtonText": "نقل",
      "dxFileManager-dialogDirectoryChooserCopyTitle": "نسخ إلى",
      "dxFileManager-dialogDirectoryChooserCopyButtonText": "نسخ",
      "dxFileManager-dialogRenameItemTitle": "إعادة تسمية",
      "dxFileManager-dialogRenameItemButtonText": "حفظ",
      "dxFileManager-dialogCreateDirectoryTitle": "مجلد جديد",
      "dxFileManager-dialogCreateDirectoryButtonText": "إنشاء",
      "dxFileManager-dialogDeleteItemTitle": "حذف",
      "dxFileManager-dialogDeleteItemButtonText": "حذف",
      "dxFileManager-dialogDeleteItemSingleItemConfirmation": "هل أنت متأكد أنك تريد حذف {0}?",
      "dxFileManager-dialogDeleteItemMultipleItemsConfirmation": "هل أنت متأكد أنك تريد حذف {0} عنصر?",
      "dxFileManager-dialogButtonCancel": "إلغاء",
      "dxFileManager-editingCreateSingleItemProcessingMessage": "جار إنشاء مجلد داخل {0}",
      "dxFileManager-editingCreateSingleItemSuccessMessage": "تم إنشاء مجلد داخل {0}",
      "dxFileManager-editingCreateSingleItemErrorMessage": "المجلد لم يتم إنشاؤه",
      "dxFileManager-editingCreateCommonErrorMessage": "المجلد لم يتم إنشاؤه",
      "dxFileManager-editingRenameSingleItemProcessingMessage": "جار إعادة تسمية عنصر داخل {0}",
      "dxFileManager-editingRenameSingleItemSuccessMessage": "تم إعادة تسمية عنصر داخل {0}",
      "dxFileManager-editingRenameSingleItemErrorMessage": "لم يتم تغير اسم العنصر",
      "dxFileManager-editingRenameCommonErrorMessage": "لم يتم تغير اسم العنصر",
      "dxFileManager-editingDeleteSingleItemProcessingMessage": "جار حذف عنصر من {0}",
      "dxFileManager-editingDeleteMultipleItemsProcessingMessage": "جار حذف {0} عناصر من {1}",
      "dxFileManager-editingDeleteSingleItemSuccessMessage": "تم حذف عنصر من {0}",
      "dxFileManager-editingDeleteMultipleItemsSuccessMessage": "تم حذف {0} عناصر من {1}",
      "dxFileManager-editingDeleteSingleItemErrorMessage": "لم يتم حذف العنصر",
      "dxFileManager-editingDeleteMultipleItemsErrorMessage": "{0} لم يتم حذف العناصر",
      "dxFileManager-editingDeleteCommonErrorMessage": "بعض العناصر لم تحذف",
      "dxFileManager-editingMoveSingleItemProcessingMessage": "جار نقل عنصر إلى {0}",
      "dxFileManager-editingMoveMultipleItemsProcessingMessage": "جار نقل {0} عناصر إلى {1}",
      "dxFileManager-editingMoveSingleItemSuccessMessage": "تم نقل عنصر إلى {0}",
      "dxFileManager-editingMoveMultipleItemsSuccessMessage": "تم نقل {0} عناصر إلى {1}",
      "dxFileManager-editingMoveSingleItemErrorMessage": "لم يتم نقل العنصر",
      "dxFileManager-editingMoveMultipleItemsErrorMessage": "{0} لم يتم نقل العناصر",
      "dxFileManager-editingMoveCommonErrorMessage": "بعض العناصر لم تنقل",
      "dxFileManager-editingCopySingleItemProcessingMessage": "جار نسخ عنصر إلى {0}",
      "dxFileManager-editingCopyMultipleItemsProcessingMessage": "جار نسخ {0} عناصر إلى {1}",
      "dxFileManager-editingCopySingleItemSuccessMessage": "تم نسخ عنصر إلى {0}",
      "dxFileManager-editingCopyMultipleItemsSuccessMessage": "تم نسخ {0} عناصر إلى {1}",
      "dxFileManager-editingCopySingleItemErrorMessage": "لم يتم نسخ العنصر",
      "dxFileManager-editingCopyMultipleItemsErrorMessage": "{0} لم يتم نسخ العناصر",
      "dxFileManager-editingCopyCommonErrorMessage": "بعض العناصر لم تنسخ",
      "dxFileManager-editingUploadSingleItemProcessingMessage": "جار تحميل عنصر إلى {0}",
      "dxFileManager-editingUploadMultipleItemsProcessingMessage": "جار تحميل {0} عناصر إلى {1}",
      "dxFileManager-editingUploadSingleItemSuccessMessage": "تم تحميل عنصر إلى {0}",
      "dxFileManager-editingUploadMultipleItemsSuccessMessage": "تم تحميل {0} عناصر إلى {1}",
      "dxFileManager-editingUploadSingleItemErrorMessage": "لم يتم تحميل العنصر",
      "dxFileManager-editingUploadMultipleItemsErrorMessage": "{0} لم يتم تحميل العناصر",
      "dxFileManager-editingUploadCanceledMessage": "تم الإلغاء",
      "dxFileManager-listDetailsColumnCaptionName": "اسم",
      "dxFileManager-listDetailsColumnCaptionDateModified": "تم تعديل التاريخ",
      "dxFileManager-listDetailsColumnCaptionFileSize": "حجم الملف",
      "dxFileManager-listThumbnailsTooltipTextSize": "حجم",
      "dxFileManager-listThumbnailsTooltipTextDateModified": "تم تعديل التاريخ",
      "dxFileManager-notificationProgressPanelTitle": "التقدم",
      "dxFileManager-notificationProgressPanelEmptyListText": "لا يوجد عمليات",
      "dxFileManager-notificationProgressPanelOperationCanceled": "تم الإلغاء",
      "dxDiagram-categoryGeneral": "عام",
      "dxDiagram-categoryFlowchart": "مخطط",
      "dxDiagram-categoryOrgChart": "مخطط هيكلي",
      "dxDiagram-categoryContainers": "حاويات",
      "dxDiagram-categoryCustom": "مخصص",
      "dxDiagram-commandExportToSvg": "تصدير إلى SVG",
      "dxDiagram-commandExportToPng": "تصدير إلى PNG",
      "dxDiagram-commandExportToJpg": "تصدير إلى JPEG",
      "dxDiagram-commandUndo": "تراجع",
      "dxDiagram-commandRedo": "إعادة",
      "dxDiagram-commandFontName": "اسم الخط",
      "dxDiagram-commandFontSize": "حجم الخط",
      "dxDiagram-commandBold": "عريض",
      "dxDiagram-commandItalic": "مائل",
      "dxDiagram-commandUnderline": "تسطير",
      "dxDiagram-commandTextColor": "لون الخط",
      "dxDiagram-commandLineColor": "لون الخط",
      "dxDiagram-commandLineWidth": "عرض الخط",
      "dxDiagram-commandLineStyle": "ستايل الخط",
      "dxDiagram-commandLineStyleSolid": "مصمت",
      "dxDiagram-commandLineStyleDotted": "منقط",
      "dxDiagram-commandLineStyleDashed": "متقطع",
      "dxDiagram-commandFillColor": "لون التعبئة",
      "dxDiagram-commandAlignLeft": "محاذاة لليسار",
      "dxDiagram-commandAlignCenter": "محاذاة للوسط",
      "dxDiagram-commandAlignRight": "محاذاة لليمين",
      "dxDiagram-commandConnectorLineType": "نوع خط الموصل",
      "dxDiagram-commandConnectorLineStraight": "مستقيم",
      "dxDiagram-commandConnectorLineOrthogonal": "متعامد",
      "dxDiagram-commandConnectorLineStart": "بدء خط الموصل",
      "dxDiagram-commandConnectorLineEnd": "نهاية خط الموصل",
      "dxDiagram-commandConnectorLineNone": "لا شيء",
      "dxDiagram-commandConnectorLineArrow": "سهم",
      "dxDiagram-commandFullscreen": "تكبير الشاشة",
      "dxDiagram-commandUnits": "وحدات",
      "dxDiagram-commandPageSize": "حجم الصفحة",
      "dxDiagram-commandPageOrientation": "اتجاه الصفحة",
      "dxDiagram-commandPageOrientationLandscape": "عرضيا",
      "dxDiagram-commandPageOrientationPortrait": "طوليا",
      "dxDiagram-commandPageColor": "لون الصفحة",
      "dxDiagram-commandShowGrid": "إظهار الشبكة",
      "dxDiagram-commandSnapToGrid": "الربط على الشبكة",
      "dxDiagram-commandGridSize": "حجم الشكبة",
      "dxDiagram-commandZoomLevel": "مستوى التكبير",
      "dxDiagram-commandAutoZoom": "تكبير تلقائي",
      "dxDiagram-commandFitToContent": "تناسب المحتوى",
      "dxDiagram-commandFitToWidth": "تناسب العرض",
      "dxDiagram-commandAutoZoomByContent": "التكبير التلقائي حسب المحتوى",
      "dxDiagram-commandAutoZoomByWidth": "التكبير التلقائي حسب العرض",
      "dxDiagram-commandSimpleView": "عرض عينة",
      "dxDiagram-commandCut": "قص",
      "dxDiagram-commandCopy": "نسخ",
      "dxDiagram-commandPaste": "لصق",
      "dxDiagram-commandSelectAll": "تحديد الكل",
      "dxDiagram-commandDelete": "حذف",
      "dxDiagram-commandBringToFront": "جلب للأمام",
      "dxDiagram-commandSendToBack": "ارجاع للخلف",
      "dxDiagram-commandLock": "قفل",
      "dxDiagram-commandUnlock": "إلغاء القفل",
      "dxDiagram-commandInsertShapeImage": "إضافة صورة...",
      "dxDiagram-commandEditShapeImage": "تغير الصورة...",
      "dxDiagram-commandDeleteShapeImage": "حذف الصورة...",
      "dxDiagram-commandLayoutLeftToRight": "من اليسار إلى اليمين",
      "dxDiagram-commandLayoutRightToLeft": "من اليمين إلى اليسار",
      "dxDiagram-commandLayoutTopToBottom": "من فوق إلى تحت",
      "dxDiagram-commandLayoutBottomToTop": "من تحت إلى فوق",
      "dxDiagram-unitIn": "إنش",
      "dxDiagram-unitCm": "سم",
      "dxDiagram-unitPx": "بكسل",
      "dxDiagram-dialogButtonOK": "حسنا",
      "dxDiagram-dialogButtonCancel": "إلغاء",
      "dxDiagram-dialogInsertShapeImageTitle": "إدراج صورة",
      "dxDiagram-dialogEditShapeImageTitle": "تغير صورة",
      "dxDiagram-dialogEditShapeImageSelectButton": "تحديد صورة",
      "dxDiagram-dialogEditShapeImageLabelText": "أو قم بإسقاط الملف هنا",
      "dxDiagram-uiExport": "تصدير",
      "dxDiagram-uiProperties": "خصائص",
      "dxDiagram-uiSettings": "إعدادات",
      "dxDiagram-uiShowToolbox": "إظهار صندوق الأدوات",
      "dxDiagram-uiSearch": "بحث",
      "dxDiagram-uiStyle": "ستايل",
      "dxDiagram-uiLayout": "طبقة",
      "dxDiagram-uiLayoutTree": "شجرة",
      "dxDiagram-uiLayoutLayered": "مطبقة",
      "dxDiagram-uiDiagram": "رسم بياني",
      "dxDiagram-uiText": "نص",
      "dxDiagram-uiObject": "غرض",
      "dxDiagram-uiConnector": "موصل",
      "dxDiagram-uiPage": "صفحة",
      "dxDiagram-shapeText": "نص",
      "dxDiagram-shapeRectangle": "مستطيل",
      "dxDiagram-shapeEllipse": "بيضوي",
      "dxDiagram-shapeCross": "تقاطع",
      "dxDiagram-shapeTriangle": "مثلث",
      "dxDiagram-shapeDiamond": "معين",
      "dxDiagram-shapeHeart": "قلب",
      "dxDiagram-shapePentagon": "خماسي الأضلاع",
      "dxDiagram-shapeHexagon": "سداسي الأضلاع",
      "dxDiagram-shapeOctagon": "ثماني الأضلاع",
      "dxDiagram-shapeStar": "بداية",
      "dxDiagram-shapeArrowLeft": "سهم لليسار",
      "dxDiagram-shapeArrowUp": "سهم للأعلى",
      "dxDiagram-shapeArrowRight": "سهم لليمين",
      "dxDiagram-shapeArrowDown": "سهم للأسفل",
      "dxDiagram-shapeArrowUpDown": "سهم سفلي علوي",
      "dxDiagram-shapeArrowLeftRight": "سهم يساري يميني",
      "dxDiagram-shapeProcess": "معالجة",
      "dxDiagram-shapeDecision": "قرار",
      "dxDiagram-shapeTerminator": "فاصل",
      "dxDiagram-shapePredefinedProcess": "عملية محددة مسبقا",
      "dxDiagram-shapeDocument": "مستند",
      "dxDiagram-shapeMultipleDocuments": "مستندات متعددة",
      "dxDiagram-shapeManualInput": "إدخال يدوي",
      "dxDiagram-shapePreparation": "تحضير",
      "dxDiagram-shapeData": "بيانات",
      "dxDiagram-shapeDatabase": "قاعدة بيانات",
      "dxDiagram-shapeHardDisk": "القرص الصلب",
      "dxDiagram-shapeInternalStorage": "تخزين داخلي",
      "dxDiagram-shapePaperTape": "شريط ورقي",
      "dxDiagram-shapeManualOperation": "التشغيل اليدوي",
      "dxDiagram-shapeDelay": "تأخير",
      "dxDiagram-shapeStoredData": "بيانات نخزنة",
      "dxDiagram-shapeDisplay": "عرض",
      "dxDiagram-shapeMerge": "دمج",
      "dxDiagram-shapeConnector": "موصل",
      "dxDiagram-shapeOr": "أو",
      "dxDiagram-shapeSummingJunction": "تقاطع جمع",
      "dxDiagram-shapeContainerDefaultText": "حاوي",
      "dxDiagram-shapeVerticalContainer": "حاوية عمودية",
      "dxDiagram-shapeHorizontalContainer": "حاوية أفقية",
      "dxDiagram-shapeCardDefaultText": "اسم الشخص",
      "dxDiagram-shapeCardWithImageOnLeft": "بطاقة بصورة على اليسار",
      "dxDiagram-shapeCardWithImageOnTop": "بطاقة بصورة في الأعلى",
      "dxDiagram-shapeCardWithImageOnRight": "بطاقة بصورة على اليمين",
      "dxGantt-dialogTitle": "عنوان",
      "dxGantt-dialogStartTitle": "بداية",
      "dxGantt-dialogEndTitle": "نهاية",
      "dxGantt-dialogProgressTitle": "عملية",
      "dxGantt-dialogResourcesTitle": "موارد",
      "dxGantt-dialogResourceManagerTitle": "مدير موارد",
      "dxGantt-dialogTaskDetailsTitle": "تفاصيل المهمة",
      "dxGantt-dialogEditResourceListHint": "تعديل قائمة الموارد",
      "dxGantt-dialogEditNoResources": "لا يوجد موارد",
      "dxGantt-dialogButtonAdd": "إضافة",
      "dxGantt-contextMenuNewTask": "مهمة جديدة",
      "dxGantt-contextMenuNewSubtask": "مهمة فرعية جديدة",
      "dxGantt-contextMenuDeleteTask": "حذف المهمة",
      "dxGantt-contextMenuDeleteDependency": "حذف التبعية",
      "dxGantt-dialogTaskDeleteConfirmation": "يؤدي حذف مهمة أيضًا إلى حذف جميع تبعياتها ومهامها الفرعية. هل أنت متأكد أنك تريد حذف هذه المهمة؟",
      "dxGantt-dialogDependencyDeleteConfirmation": "هل أنت متأكد أنك تريد حذف التبعية من المهمة؟",
      "dxGantt-dialogResourcesDeleteConfirmation": "يؤدي حذف المورد أيضًا إلى حذفه من المهام التي تم تعيين هذا المورد لها. هل أنت متأكد أنك تريد حذف هذه الموارد؟ المورد: {0}",
      "dxGantt-dialogConstraintCriticalViolationMessage": "المهمة التي تحاول نقلها مرتبطة بمهمة ثانية بعلاقة تبعية. قد يتعارض هذا التغيير مع قواعد التبعية. كيف تريد المتابعة؟",
      "dxGantt-dialogConstraintViolationMessage": "المهمة التي تحاول نقلها مرتبطة بمهمة ثانية بعلاقة تبعية. كيف تريد المتابعة؟",
      "dxGantt-dialogCancelOperationMessage": "إلغاء العملية",
      "dxGantt-dialogDeleteDependencyMessage": "حذف التبعية",
      "dxGantt-dialogMoveTaskAndKeepDependencyMessage": "انقل المهمة واحتفظ بالتبعية",
      "dxGantt-undo": "تراجع",
      "dxGantt-redo": "إعادة",
      "dxGantt-expandAll": "توسيع الكل",
      "dxGantt-collapseAll": "طي الكل",
      "dxGantt-addNewTask": "إضافة مهمة جديدة",
      "dxGantt-deleteSelectedTask": "حذف المهمة المحددة",
      "dxGantt-zoomIn": "تكبير",
      "dxGantt-zoomOut": "تصغير",
      "dxGantt-fullScreen": "تكبير الشاشة"
    }
  }